












































import { Component, Vue, Watch } from 'vue-property-decorator';
import UserProfileGeneral from './Read/UserProfileGeneral.vue';
import UserProfileChangePassword from './Read/UserProfileChangePassword.vue';
import UserProfileBusinessList from './Read/UserProfileBusinessList.vue';
import UserProfilePrivilege from './Read/UserProfilePrivilege.vue';
import { mapState } from 'vuex';

@Component({
  components: {
    UserProfileGeneral,
    UserProfileChangePassword,
    UserProfileBusinessList,
    UserProfilePrivilege,
  },
  computed: {
    ...mapState('Auth', {
      activeRoleKey: 'activeRoleKey',
    }),
    ...mapState('User', {
      user: 'adminUser',
    }),
  },
})
export default class UserRead extends Vue {
  sidebarIndex = 0;

  unactivatedAlert = false;

  user!: Model;

  isMounted = false;

  isLoading = false;

  isApiFetch = {
    isApiFetchUserFinished: false,
    isApiFetchGroupFinished: false,
    isApiFetchKeysFinished: false,
    isApiFetchAllBusinessedFinished: false,
  };

  get sidebarItems() {
    return [
      {
        title: 'General',
      },
      {
        title: 'Change Password',
      },
      {
        title: 'Business Permissions',
      },
      ...(this.$acl.check('allowPrivilegeCRUD')
        ? [
            {
              title: 'General Privileges',
            },
          ]
        : []),
    ];
  }

  async mounted() {
    this.$store
      .dispatch('User/fetch', {
        id: this.$route.params.userId,
      })
      .then(() => {
        this.isApiFetch['isApiFetchUserFinished'] = true;
      });
    this.$store.dispatch('User/groups').then(() => {
      this.isApiFetch['isApiFetchGroupFinished'] = true;
    });
    this.$store.dispatch('Authorization/keys').then(() => {
      this.isApiFetch['isApiFetchKeysFinished'] = true;
    });
    this.$store.dispatch('Business/all').then(() => {
      this.isApiFetch['isApiFetchAllBusinessedFinished'] = true;
    });
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (isFinished) {
        this.unactivatedAlert = !this.user.is_activated;
        this.isMounted = true;
      }
    }
  }

  activate() {
    this.isLoading = true;
    this.$store
      .dispatch('User/activate', {
        id: this.user.id,
      })
      .then(() => {
        this.unactivatedAlert = !this.user.is_activated;
        if (this.user.is_activated) {
          this.$store.commit('SET_SNACKBAR', {
            show: true,
            type: 'success',
            message: 'User has been activated!',
          });
        }
        this.isLoading = false;
      });
  }
}
